import { Slugs } from 'common/urls/Slugs';
import { useCallback } from 'react';
import { useRouteMatch } from 'react-router';
import { useHistory } from 'src/shared/hooks/useHistory';
import { Routes } from 'src/shared/Routes';
import { getSlug, getSluggedPath } from 'src/shared/utils/RouteUtilities';

export const useGotoReviews = () => {
  const match = useRouteMatch();
  const history = useHistory();

  const gotoReviews = useCallback(() => {
    const querySlug = getSlug(match, Slugs.QUERY);
    const idSlug = getSlug(match, Slugs.ID);
    const slugs = [
      { slug: Slugs.ID, value: idSlug },
      { slug: Slugs.QUERY, value: querySlug },
    ];
    const reviews = getSluggedPath(Routes.CONSUMER_ORDER_REVIEWS, slugs);
    history.push(reviews, { scrollToTop: false });
  }, [history, match]);

  return gotoReviews;
};
